// extracted by mini-css-extract-plugin
module.exports = {"indexPageLayout":"index-module--indexPageLayout--1ycfp","productRoll":"index-module--productRoll--1Tqgx","hero":"index-module--hero--2Osae"};